import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormText,
  Modal
} from 'reactstrap';
import { validate } from '../services/validate';
import axios from 'axios';
import StorageService from '../services/StorageService';

const billing_type = [ 'TRIAL', 'FREE', 'MONTHLY', 'YEARLY', 'SUSPENDED'];
const payment_status = [ 'FREE', 'PENDING PAYMENT', 'PAID'];
const plan = [ 'FREE', 'BASIC', 'PREMIUM', 'ENTERPRISE'];

class PosLicensingForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            company_id: '',
            company_name: '',
            startdate: '',
            disable: 0,
            billing_type: billing_type[0],
            next_bill: '',
            billing_amt: '',
            payment_status: payment_status[0],
            plan: plan[0],
            store_limit: 0,
            ecart_limit: 0,
            product_limit: 0,
            customer_limit: 0,
            errors: {
                startdate: '',
                billing_type: '',
                next_bill: '',
                billing_amt: '',
                payment_status: '',
                plan: '',
            },
            pos_feature: {
              Id: '',
              Feature: 'POS',
              RowOrder: 2
            }
        };
    }

    changeHandler = event => {
        this.setState({
        [event.target.name]: event.target.value,
        });
    };

    toggleDisable = event => {
        this.setState({ disable: event.target.checked ? 1: 0 });
    };

    validateForm = (errors) => {
        let valid = true;
        Object.values(errors).forEach(
          (val) => val.length > 0 && (valid = false)
        );
        return valid;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { startdate, billing_type, next_bill, billing_amt, payment_status, plan } = this.state;
        let errors = this.state.errors;

        errors.startdate = (!validate.emptystring(startdate)) ? 'Invalid input. Please enter start date' : '';
        errors.billing_type = (!validate.emptystring(billing_type)) ? 'Invalid input. Please select billing type' : '';
        errors.next_bill = (!validate.emptystring(next_bill)) ? 'Invalid input. Please enter next bill date' : '';
        errors.billing_amt = (!validate.emptystring(billing_amt)) ? 'Invalid input. Please enter billing amount' : !(/^\d+(,\d{3})*(\.\d{1,2})?$/.test(billing_amt)) ? 'Invalid amount' : '';
        errors.payment_status = (!validate.emptystring(payment_status)) ? 'Invalid input. Please select payment' : '';
        errors.plan = (!validate.emptystring(plan)) ? 'Invalid input. Please select plan' : '';
        

        if(this.validateForm(errors)) {
            if(this.props.isEdit) {
                this.props.update(this.state);
            } else {
                
            }
        }

        this.setState({
            errors
        });
    };

    getFeatureList = (company_id) => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      CompanyID: company_id,
    };

    axios
      .post(url + ':3000/v1/company/getFeature', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        let feature = {
          Id: '',
          Feature: 'POS',
          RowOrder: 2
        };

        if (result.data.length) {
          let found = result.data.find(e => e.Feature === "POS");
          if(found) {
            feature = found;
          }
        }

        this.setState({ pos_feature: feature });
      })
      .catch(error => {
        console.log(error)
      });
  };

    componentDidMount() {
        this.setState({
            errors: {
                startdate: '',
                billing_type: '',
                next_bill: '',
                billing_amt: '',
                payment_status: '',
                plan: '',
            }
        });

        if(this.props.isEdit) {
            if(this.props.item) {
                this.setState({
                    ...this.props.item
                }, () => this.getFeatureList(this.props.item.company_id));
            }
        }
    }

  render() {
    const isEdit = this.props.isEdit;
    const { errors } = this.state;

    return (
        
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.toggle('ADD', null)}>
          {isEdit ? 'Edit' : 'Create' } POS Licensing
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
            <FormGroup>
                <Label for="company_name">Company</Label>
                <Input
                  type="text"
                  name="company_name"
                  value={this.state.company_name}
                  disabled={true}
                  onChange={this.changeHandler}
                />
              </FormGroup>
              <FormGroup>
                <Label for="startdate">Start Date</Label>
                <Input
                  type="date"
                  name="startdate"
                  value={this.state.startdate}
                  onChange={this.changeHandler}
                />
                {errors.startdate.length > 0 && <FormText color="danger">{errors.startdate}</FormText>}  
              </FormGroup>
              <FormGroup>
                <Label for="next_bill">Next Bill</Label>
                <Input
                  type="date"
                  name="next_bill"
                  value={this.state.next_bill}
                  onChange={this.changeHandler}
                />
                {errors.next_bill.length > 0 && <FormText color="danger">{errors.next_bill}</FormText>}  
              </FormGroup>
              <FormGroup>
                <Label for="billing_type">Billing Type</Label>
                <Input
                  type="select"
                  name="billing_type"
                  value={this.state.billing_type}
                  onChange={this.changeHandler}
                >
                    {billing_type.map((i, index) => {
                      return (
                        <option key={index} value={i}>{i}</option>
                      );
                    })}
                </Input>
                {errors.billing_type.length > 0 && <FormText color="danger">{errors.billing_type}</FormText>} 
              </FormGroup>
              <FormGroup>
                <Label for="billing_amt">Billing Amount</Label>
                <Input
                  type="text"
                  name="billing_amt"
                  value={this.state.billing_amt}
                  onChange={this.changeHandler}
                  
                />
              </FormGroup>
              {errors.billing_amt.length > 0 && <FormText color="danger">{errors.billing_amt}</FormText>}  
              <FormGroup>
                <Label for="payment_status">Payment Status</Label>
                <Input
                  type="select"
                  name="payment_status"
                  value={this.state.payment_status}
                  onChange={this.changeHandler}
                >
                    {payment_status.map((i, index) => {
                      return (
                        <option key={index} value={i}>{i}</option>
                      );
                    })}
                </Input>
                {errors.payment_status.length > 0 && <FormText color="danger">{errors.payment_status}</FormText>} 
              </FormGroup>
              <FormGroup>
                <Label for="plan">Plan</Label>
                <Input
                  type="select"
                  name="plan"
                  value={this.state.plan}
                  onChange={this.changeHandler}
                >
                    {plan.map((i, index) => {
                      return (
                        <option key={index} value={i}>{i}</option>
                      );
                    })}
                </Input>
                {errors.plan.length > 0 && <FormText color="danger">{errors.plan}</FormText>} 
              </FormGroup>
              <FormGroup>
                <Label for="store_limit">Store Limit</Label>
                <Input
                  type="number"
                  name="store_limit"
                  value={this.state.store_limit}
                  onChange={this.changeHandler}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label for="ecart_limit">ECart Limit</Label>
                <Input
                  type="number"
                  name="ecart_limit"
                  value={this.state.ecart_limit}
                  onChange={this.changeHandler}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label for="product_limit">Product Limit</Label>
                <Input
                  type="number"
                  name="product_limit"
                  value={this.state.product_limit}
                  onChange={this.changeHandler}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label for="customer_limit">Customer Limit</Label>
                <Input
                  type="number"
                  name="customer_limit"
                  value={this.state.customer_limit}
                  onChange={this.changeHandler}
                  
                />
              </FormGroup>

              <FormGroup check>
                <Label check style={{fontSize:'0.85rem'}}>
                  <Input type="checkbox" name="disable" checked={this.state.disable > 0 ? true : false} onChange={this.toggleDisable} />{' '}
                  Disable POS
                </Label>
              </FormGroup>
              <br/>
              <span>Note that POS feature will be enabled/disabled as well when you enable/disable POS licensing.</span>
              
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.toggle('ADD', null)}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
          {isEdit ? 'Save Changes' : 'Create' }
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default PosLicensingForm;
